import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import '../Workflow.scss'
import classnames from 'classnames'
import { TaskStatus } from '../../../services/TaskStatus';
import { useTaskStatus } from '../../hooks/useTaskStatusHook';
import { WorkflowTasks, SuccessfulStatus, VirWorkflowStateIdentifiers } from '../../../services/WorkflowTasks';
import PrepareReturnVirApi from '../../../../../services/api/prepareReturnVirApi';
import WorkflowTask from '../../../../../components/library/workflow-tasks/WorkflowTask'
import WorkflowTaskDescriptionWithHelp from '../../../../../components/library/workflow-tasks/WorkflowTaskDescriptionWithHelp';
import WorkflowTaskResetModal from '../../../../../components/library/workflow-tasks/WorkflowTaskResetModal';
import TicketActions from '../../../../../store/ticketRedux';
import VerticalNameChildren from '../../../../../components/library/layout/VerticalNameChildren';
import LoadingTextValue from '../../../../../components/library/layout/LoadingTextValue';
import HrbTranslate from '../../../../../components/language/HrbTranslate';
import DateTime from '../../../../../components/library/common/DateTime';
import EmdashText from '../../../../../components/library/common/EmdashText';
import Button from '../../../../../components/library/buttons/Button';
import DoxExplorer from '../../dox/Explorer/doxExplorer';
import DoxUploader from '../../dox/Uploader/doxUploader';
import { useTicketState } from '../../hooks/useTicketStateHook';
import { useInterviewInfo } from '../../hooks/useInterviewInfoHook';
import { createInProgressTaskCompletionObject } from '../../../services/prepare/PrepareUtils';
import TaskErrorText from '../../../../../components/library/workflow-tasks/TaskErrorText';
import ViewDownloadDocument from '../../../../../components/library/documents/ViewDownloadDocument';



const ClientCallDocumentsVirTask = (props) => {
    const ticketIsOpen = useTicketState(props.ticket);
    const [baseStatus, completions] = useTaskStatus(props.ticket, [WorkflowTasks.CLIENT_CALL_DOCUMENTS_VIR]);
    const [status, setStatus] = useState(TaskStatus.NOT_STARTED)
    const [hasUploaderError, setHasUploaderError] = useState(false);
    const [sendingForSignatures, setSendingForSignatures] = useState(false);
    const [uploaderOpen, setUploaderOpen] = useState(false);
    const [explorerShowing, setExplorerShowing] = useState(false);
    const [hasUploadedFiles, setHasUploadedFiles] = useState(false);
    const [returnType, , , primaryName, spouseName] = useInterviewInfo(props.ticket);
    const [errorList, setErrorList] = useState([]);
    const [sendForSignaturesErrorT1, setSendForSignaturesErrorT1] = useState(false);
    const [sendForSignaturesErrorT183, setSendForSignaturesErrorT183] = useState(false);
    const [sendForSignaturesErrorRC71, setSendForSignaturesErrorRC71] = useState(false);
    const [sendForSignaturesErrorPOA, setSendForSignaturesErrorPOA] = useState(false);
    const [disableSendForSignature, setDisableSendForSignature] = useState(false);
    const [enableResetDocument, setEnableResetDocument] = useState(false);    
    const [resettingDocument, setResettingDocument] = useState(false);    
    const [resetDocumentErrorRC71, setResetDocumentErrorRC71] = useState(false);
    const [resetModalShowing, setResetModalShowing] = useState(false);
    const [showNoReset, setShowNoReset] = useState(false);
    const dispatch = useDispatch();
    const api = PrepareReturnVirApi.create();
    useEffect(() => {       

        var confirmReadyToFile = props.ticket.taskCompletionStates.filter(x => x.workflowTaskId === WorkflowTasks.VIR_READY_TO_FILE && x.status.toUpperCase() === SuccessfulStatus)
        var confirmASigning = props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.RC71_P && y.status.toUpperCase() === SuccessfulStatus).length > 0 ||
            props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.POA_P && y.status.toUpperCase() === SuccessfulStatus).length > 0 ||
            props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.RETURN_REVIEWED && y.status.toUpperCase() === SuccessfulStatus).length > 0;
        var disableDocSentForSignature = props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.VIR_CONFIRM_UPLOAD && y.status.toUpperCase() === SuccessfulStatus).length > 0 ||
            props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.INTERVIEW_COMPLETED && y.status.toUpperCase() === SuccessfulStatus).length === 0 ||
            props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.AUTHORIZE_CRA && y.status.toUpperCase() === SuccessfulStatus).length === 0 ||
            props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.CONFIRM_ID && y.status.toUpperCase() === SuccessfulStatus).length === 0 ||
            props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.DOCS_UPLOADED && y.status.toUpperCase() === SuccessfulStatus).length === 0;
        var enableResetDocument = props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.VIR_CONFIRM_UPLOAD && y.status.toUpperCase() === SuccessfulStatus).length > 0 &&
            props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.VIR_READY_TO_FILE && y.status.toUpperCase() === SuccessfulStatus).length === 0;     
        
        if (enableResetDocument) {
            setEnableResetDocument(true);
        }

        if (disableDocSentForSignature) {
            setDisableSendForSignature(true)            
        } else {
            setDisableSendForSignature(false) 
        }

        if ((status === TaskStatus.NOT_STARTED && confirmASigning) || 
            props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.VIR_CONFIRM_UPLOAD).length > 0) {
            setStatus(TaskStatus.IN_PROGRESS);
        }

        if (status === TaskStatus.IN_PROGRESS && props.readyToFile) {
            setStatus(TaskStatus.COMPLETE);
        }

        if (confirmReadyToFile.length > 0) {
            setStatus(TaskStatus.COMPLETE);
            setShowNoReset(true);
            setEnableResetDocument(false);
        }

    }, [props.ticket, props.readyToFile])

    const handleShowModal = () => {
        setResetModalShowing(true)
    }
    
    const handleHideModal = () => {
        setResetModalShowing(false);
    }

    const handleLaunchTPSAction = () => {
        if (status === TaskStatus.NOT_STARTED) {
            setStatus(TaskStatus.IN_PROGRESS);
        }        
        let myWindow = window.open();
        myWindow.location.href = localStorage.getItem('tps_base_uri') + `/${props.ticket.taxYear}/return/${props.ticket.viewModelId}/efile/efile?isvir=true`;
    }

    const handleSendForSignatures = async () => {

        if (status === TaskStatus.NOT_STARTED) {
            setStatus(TaskStatus.IN_PROGRESS);
        }
        if (props.ticket) {
            setSendingForSignatures(true)
            setSendForSignaturesErrorT1(false)
            setSendForSignaturesErrorT183(false)
            setSendForSignaturesErrorRC71(false)
            setSendForSignaturesErrorPOA(false)

            var response = await api.sendForSigningTask(props.ticket.id)
            if (response && response.ok) {
                if (response.data.statusCode === 'SUCCESS') {
                    dispatch(TicketActions.getTicket(props.ticket.id))                   
                    setDisableSendForSignature(true)
                }
                else {
                    if (response.data.statusCode.includes('T1_'))
                        setSendForSignaturesErrorT1(true)
                    if (response.data.statusCode.includes('T183'))
                        setSendForSignaturesErrorT183(true)
                    if (response.data.statusCode.includes('RC71'))
                        setSendForSignaturesErrorRC71(true)
                    if (response.data.statusCode.includes('POA'))
                        setSendForSignaturesErrorPOA(true)
                }                
            }
        }
        setSendingForSignatures(false);
    }

    const handleResetDocument = async () => {
        if (props.ticket) {
            setResettingDocument(true)

            var response = await api.sendForResettingDocuments(props.ticket.id)
            if (response && response.ok) {
                if (response.data.statusCode === 'SUCCESS') {
                    dispatch(TicketActions.getTicket(props.ticket.id)) ;                  
                    setEnableResetDocument(false);
                }
                else {
                    if (response.data.statusCode.includes('RC71'))
                        setResetDocumentErrorRC71(true);
                }                
            }
        }
        setResettingDocument(false);
        setResetModalShowing(false);
    }

    const showUploader = () => {
        setUploaderOpen(true)
    }

    const onCloseUploader = () => {
        setUploaderOpen(false);
    }

    const onUploadsComplete = async (filesWereUploaded) => {
        if (filesWereUploaded) {
            setHasUploadedFiles(true);

            var payload = createInProgressTaskCompletionObject(
                (completions || []).find(x => x.status !== TaskStatus.INVALID), null, true);
            saveCompletion(payload);
        }

        setUploaderOpen(false);
    }

    const saveCompletion = async (payload) => {       
        setSendingForSignatures(false);
    }

    const showExplorer = () => {
        setExplorerShowing(true)
    }

    const onExplorerClose = () => {
        setExplorerShowing(false)
    }

    const getFileId = (taskId) => {
        var cs;
        var taskCompletions = props.ticket.taskCompletionStates;

        cs = taskCompletions.filter(c => c.workflowTaskId === taskId && c.status === 'CompletedSuccessfully')

        if (cs && cs[0])
            return true

        return false
    }

    const handleViewDownloadFail = (docType) => {
        if (!errorList.includes(docType)) {
            setErrorList([...errorList, docType])
        }
    }

    const getVirSigningCompleteDate = (filer) => {
        var confirmASigning = props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.RC71_P && y.status.toUpperCase() === SuccessfulStatus).length > 0 ||
            props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.POA_P && y.status.toUpperCase() === SuccessfulStatus).length > 0 ||
            props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.RETURN_REVIEWED && y.status.toUpperCase() === SuccessfulStatus).length > 0;

        if (confirmASigning) {
            var rc71SigningDate = null;
            if (props.ticket.taskCompletionStates.filter(x => x.workflowTaskId === WorkflowTasks.RC71_P && x.status.toUpperCase() === SuccessfulStatus).length > 0) {
                rc71SigningDate = props.ticket.taskCompletionStates.filter(
                    x => x.workflowTaskId === WorkflowTasks.RC71_P && x.status.toUpperCase() === SuccessfulStatus).length > 0 ? 
                        JSON.parse(props.ticket.taskCompletionStates.filter(x => x.workflowTaskId === WorkflowTasks.RC71_P && x.status.toUpperCase() === SuccessfulStatus)[0].completionData).dateTimeSigned : null;
            }

            var poaSigningDate = null;
            if (props.ticket.taskCompletionStates.filter(x => x.workflowTaskId === WorkflowTasks.POA_P && x.status.toUpperCase() === SuccessfulStatus).length > 0) {
                poaSigningDate = props.ticket.taskCompletionStates.filter(
                    x => x.workflowTaskId === WorkflowTasks.POA_P && x.status.toUpperCase() === SuccessfulStatus).length > 0 ? 
                        JSON.parse(props.ticket.taskCompletionStates.filter(x => x.workflowTaskId === WorkflowTasks.POA_P && x.status.toUpperCase() === SuccessfulStatus)[0].completionData).dateTimeSigned : null;
            }

            if (rc71SigningDate) {
                return rc71SigningDate;
            }

            if (poaSigningDate) {
                return poaSigningDate;
            }

        }
        return null;
    }

    return (
        <WorkflowTask status={status} taskId={WorkflowTasks.CLIENT_CALL_DOCUMENTS_VIR}>
            <div className='columns'>
                <WorkflowTaskDescriptionWithHelp
                    helpKey='0ProSupport/VDOPro/ClientCallDocuments.htm'
                    descriptions={['ClientCallDocumentsVirTask.Step1', 'ClientCallDocumentsVirTask.Step1Info']} />
            </div>
            <div className='columns'>
                <div className='column is-offset-1 is-10'>
                    <div className='prep-border' />
                </div>
            </div>
            <div className='columns'>
                <WorkflowTaskDescriptionWithHelp                    
                    descriptions={['ClientCallDocumentsVirTask.Step2', 'ClientCallDocumentsVirTask.Step2Info1', 'ClientCallDocumentsVirTask.Step2Info2']} />
            </div>
            <div className='columns'>
                <div className='column is-10 is-offset-1'>
                    <div className='step-center-container'>
                        {props.ticket &&
                            <Button
                            elementId='launch-tps-btn'
                            labelKey='PrepareTask.LaunchTPSBtn'
                            buttonStyles='secondary'
                            onClick={handleLaunchTPSAction}
                            loading={false}
                            />}
                     </div>
                </div>
            </div>         
            <div className='columns'>
                <div className='column is-offset-1 is-10'>
                    <div className='prep-border' />
                </div>
            </div>   
            <div className='columns'>
                <WorkflowTaskDescriptionWithHelp
                    descriptions={['ClientCallDocumentsVirTask.Step3', 'ClientCallDocumentsVirTask.Step3Info1', 'ClientCallDocumentsVirTask.Step3Info2']} />                
            </div>
            <div className='columns'>
                <div className='column is-offset-1 is-10'>
                    {props.ticket &&
                        <Fragment>
                            <div className='step-center-container'>
                                <Button
                                    elementId='client-call-doc-manage-btn'
                                    labelKey='DocUploadTask.ViewManage'
                                    buttonStyles='secondary'
                                    onClick={showExplorer}
                                />
                                <Button
                                    elementId='client-call-doc-upload-btn'
                                    labelKey='PrepareTask.UploadDocs'
                                    buttonStyles='secondary'
                                    onClick={showUploader}
                                    disabled={status === TaskStatus.COMPLETE || !ticketIsOpen}
                                />
                            </div>
                            {hasUploaderError &&
                                <TaskErrorText errorKey='PrepareTask.ErrorUploader' />
                            }
                        </Fragment>
                    }
                </div>                
            </div>
            <div className='columns'>
                <div className='column is-offset-1 is-10'>
                    <div className='prep-border' />
                </div>
            </div>
            <div className='columns'>
                <WorkflowTaskDescriptionWithHelp
                    descriptions={['ClientCallDocumentsVirTask.Step4', 'ClientCallDocumentsVirTask.Step4Info1']} />
            </div>
            <WorkflowTaskResetModal
                isOpen={resetModalShowing} status={status} onCancel={handleHideModal}
                onReset={handleResetDocument} titleKey="ClientCallDocumentsVirTask.ResetModal.Title"
                resetButtonKey="ClientCallDocumentsVirTask.ResetRC71"
                contentKeys={['ClientCallDocumentsVirTask.ResetModal.Content1', 'ClientCallDocumentsVirTask.ResetModal.Content2']} />
            <div className='columns'>
                <div className='column is-10 is-offset-1'>
                    <div className='step-center-container'>
                        {props.ticket &&
                            <Button
                            elementId='send-signatures-btn'
                            labelKey='ClientCallDocumentsVirTask.SendForSignatures'
                            buttonStyles='secondary'
                            onClick={handleSendForSignatures}
                            loading={sendingForSignatures}
                            disabled={disableSendForSignature}
                            />
                            }                    
                    </div>
                    <div>{sendForSignaturesErrorT1 &&
                        <TaskErrorText errorKey='ClientCallDocumentsVirTask.ErrorMissingDocUploadT1' />
                    }</div>
                    <div>{sendForSignaturesErrorT183 &&
                        <TaskErrorText errorKey='ClientCallDocumentsVirTask.ErrorMissingDocUploadT183' />
                    }</div>
                    <div>{sendForSignaturesErrorRC71 &&
                        <TaskErrorText errorKey='ClientCallDocumentsVirTask.ErrorMissingDocUploadRC71' />
                    }</div>
                    <div>{sendForSignaturesErrorPOA &&
                        <TaskErrorText errorKey='ClientCallDocumentsVirTask.ErrorMissingDocUploadPOA' />
                    }</div>
                     <div>{resetDocumentErrorRC71 &&
                        <TaskErrorText errorKey='ClientCallDocumentsVirTask.ErrorResetRC71' />
                    }</div>
                </div>
            </div>
            <div className='columns'>
                <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                    <h4><LoadingTextValue value={primaryName} /></h4>
                </div>
                {returnType === 'coupled' &&
                    <div className='column is-5'>
                        <h4><LoadingTextValue value={spouseName} /></h4>
                    </div>
                }
            </div>
            <div className='columns'>
                <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                    <HrbTranslate text="ClientCallDocumentsVirTask.DocSignature" className='p1' />
                </div>
                {returnType === 'coupled' &&
                    <div className='column is-5'>
                    <HrbTranslate text="ClientCallDocumentsVirTask.DocSignature" className='p1' />
                    </div>
                }
            </div>

            <div className='columns approvals'>
                <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                    <ViewDownloadDocument documentType='T183_P' ticketId={props.ticket.id}
                        disabled={!Boolean(getFileId(WorkflowTasks.RETURN_REVIEWED))}
                        onViewDownloadFail={handleViewDownloadFail} />
                    {errorList.includes('T183_P') &&
                        <TaskErrorText errorKey='ClientCallDocumentsVirTask.ErrorMissingDoc' />
                    }
                </div>                
            </div>

            <div className='columns approvals'>
                <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                    <ViewDownloadDocument documentType='POA_P' ticketId={props.ticket.id}
                        disabled={!Boolean(getFileId(WorkflowTasks.POA_P))}
                        onViewDownloadFail={handleViewDownloadFail} />
                    {errorList.includes('POA_P') &&
                        <TaskErrorText errorKey='ClientCallDocumentsVirTask.ErrorMissingDoc' />
                    }
                </div>               
            </div>

            <div className='columns approvals'>
                <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                    <ViewDownloadDocument documentType='RC71_P' ticketId={props.ticket.id}
                        disabled={!Boolean(getFileId(WorkflowTasks.RC71_P))}
                        onViewDownloadFail={handleViewDownloadFail} />
                    {errorList.includes('RC71_P') &&
                        <TaskErrorText errorKey='ClientCallDocumentsVirTask.ErrorMissingDoc' />
                    }
                </div>
            </div>
            <div className='columns'>
                <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                    <HrbTranslate text="ClientCallDocumentsVirTask.DocReview" className='p1' />
                </div>
                {returnType === 'coupled' &&
                    <div className='column is-5'>
                    <HrbTranslate text="ClientCallDocumentsVirTask.DocReview" className='p1' />
                    </div>
                }
            </div>
            <div className='columns approvals'>
                <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                    <ViewDownloadDocument documentType='T1_P' ticketId={props.ticket.id}
                        disabled={!Boolean(getFileId('RETURN_REVIEWED'))}
                        onViewDownloadFail={handleViewDownloadFail} />
                    {errorList.includes('T1_P') &&
                        <TaskErrorText errorKey='ClientCallDocumentsVirTask.ErrorMissingDoc' />
                    }
                </div>                
            </div>
            <div className='columns note-content'>
                {showNoReset ? 
                    <WorkflowTaskDescriptionWithHelp descriptions={['ClientCallDocumentsVirTask.NoResetNotes']} /> 
                    : <WorkflowTaskDescriptionWithHelp descriptions={['ClientCallDocumentsVirTask.ResetNotes']} />}                        
            </div>
            <div className='step-center-container'>           
                {props.ticket &&
                    <Button
                        elementId='reset-document-btn'
                        labelKey='ClientCallDocumentsVirTask.ResetRC71'
                        buttonStyles='secondary'
                        onClick={handleShowModal}
                        loading={resettingDocument}
                        disabled={!enableResetDocument}
                    />
                }  
             </div> 
            <div className='columns'>
                <div className='column is-10 is-offset-1 prep-border small-margins' />
            </div>
            <div className='columns'>
                <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                    <VerticalNameChildren
                        textKey="ClientCallDocumentsVirTask.SignedOn"
                        loading={!props.ticket}>
                        <p className='p1 medium-weight'>
                            <DateTime dateAndTime value={getVirSigningCompleteDate('PRIMARY')} fallbackValue={<EmdashText />} />
                        </p>
                    </VerticalNameChildren>
                </div>                
            </div>
            <DoxExplorer ticket={props.ticket} show={explorerShowing}
                onClose={onExplorerClose}
            />
            <DoxUploader ticket={props.ticket} show={uploaderOpen}
                layoutType={'desktop'} onUploadsComplete={onUploadsComplete} onClose={onCloseUploader}
            />
        </WorkflowTask>
    );
}

ClientCallDocumentsVirTask.whyDidYouRender = false;

ClientCallDocumentsVirTask.propTypes = {
    ticket: PropTypes.object
}

export default ClientCallDocumentsVirTask